<template>
<div>
    <updateCardWindow :baseUrl="baseUrl" v-if="showCard" @CloseBox="showCard=false"></updateCardWindow>
    <confirm-cancel :baseUrl="baseUrl" :subtoCancel="subtoCancel" @CloseBox="cancelSubs = false;" @ShowToastForCancel="ShowToastForCancel" @ShowToastForCancelError="ShowToastForCancelError" v-if="cancelSubs" />
    <toast-window :message="toastMessage" v-if="showT" />
    <div class="portal-tab-div history">
        <div class="account-summary-div">
            <div class="therapy-subs-div">
                <div class="portal-summary-header">Current Therapies</div>

                <div class="order-div portal order-info" v-for="subs in subscriptions" :key="subs.id">
                    <div class="div-block-960 new">
                        <div class="div-block-976"><img sizes="55px" :srcset="`https://prioritymeds.s3.us-east-1.amazonaws.com/public/assets/product_image/webp/${getItemImage(subs.plan_name)}/1.webp`" :alt="subs.plan_name" :src="`https://prioritymeds.s3.us-east-1.amazonaws.com/public/assets/product_image/webp/${getItemImage(subs.plan_name)}/1.webp`" loading="lazy" class="image-444">
                            <div>
                                <div class="product-name-2 portal">{{subs.plan_name}}<br></div>
                                <div class="text-block-850">Next Payment: {{subs.next_billing_date.split("T")[0]}}</div>
                            </div>
                        </div>
                        <div class="div-block-1778">
                            <div class="item-price-text">${{subs.amount}}</div>
                            <div class="text-block-849">Billed monthly</div>
                        </div>
                    </div>
                    <a href="#" class="link-51" @click.prevent="setSubscriptionToCancel(subs)" >Cancel Subscription</a>
                </div>
                <div class="div-block-1117 b div-block-1847 portal">
                    <div class="div-block-1120">
                        <a href="#" class="button-44 w-button" @click.prevent="showCard=true" style="color:#fff">Update Credit Card</a>
                    </div>
                </div>
            </div>
            <div class="payment-history-div">
                <div class="portal-summary-header">Past Payments</div>
                <div class="div-block-1119" v-for="trans in transactionItems" :key="`trans-${trans.id}`">
                    <div class="text-block-231">${{trans.amount}} - {{ trans.status }} - {{trans.created_at.split("T")[0]}}</div>
                    <a href="#" v-if="trans.status==='success'" @click.prevent="downloadInvoice(trans.transaction_id,trans.product_name)" class="link-16">Download Receipt</a>
                </div>

            </div>
        </div>
    </div>
</div>
</template>

<script>
import html2pdf from 'html2pdf.js';
import updateCardWindow from './updateCardWindow.vue';
import confirmationWindow from './confirmationWindow.vue'
import tostWindow from './tostWindow.vue'
export default {
    name: 'HomePage',
    components: {
        updateCardWindow,
        'confirm-cancel': confirmationWindow,
        'toast-window': tostWindow
    },
    props: {
        baseUrl: {
            type: String,
            required: true
        },
        user: {
            type: Object,
            required: true
        },
    },

    data() {
        return {
            showCard: false,
            subscriptions: [],
            transactionItems: [],
            cancelSubs: false,
            toastMessage: '',
            showT: false,
            subtoCancel: '',
        }
    },

    computed: {},
    mounted() {
        this.getSubscriptions();
        this.getTransactions();
    },
    methods: {
        setSubscriptionToCancel(subs){
            this.subtoCancel = subs;
            this.cancelSubs = true;
        },
        async downloadInvoice(paymentIntentId, program) {
            try {

                await this.$axios.get(`${this.baseUrl}/api/invoice?id=${paymentIntentId}&program=${program}`).then(response => {
                    if (response.data.status == 'error') {
                        console.log("error");
                    } else {

                        const options = {
                            margin: 0, // Set margin to 10mm
                            filename: `${paymentIntentId}.pdf`, // Specify filename
                            image: {
                                type: 'jpeg',
                                quality: 1
                            }, // Specify image quality
                            html2canvas: {
                                dpi: 300,
                                scale: 4,
                                letterRendering: true,
                                useCORS: true,
                                windowWidth: 794,
                                windowHeight: 1123,
                                scrollX: 0,
                                scrollY: 0,
                                onrendered: function (canvas) {
                                    canvas.style.imageRendering = 'pixelated';
                                    canvas.style.imageRendering = '-webkit-optimize-contrast';
                                }
                            }, // Scale up html2canvas
                            jsPDF: {
                                unit: 'mm',
                                format: [210, 297],
                                orientation: 'portrait',
                                compress: true,
                                precision: 16,
                                userUnit: 1.0,
                                textColor: "#000000", // Force black text
                                fillColor: "#000000" // Force black fill
                            } // Set PDF format and orientation
                        };
                        html2pdf().set(options).from(response.data).save();
                        console.log("generated");

                    }
                });
            } catch (error) {
                console.error('Error downloading invoice:', error);
            }
        },
        getSubscriptionPrice() {

            return 349;
        },
        getItemImage(id) {
            try {

                return id.toLowerCase()
            } catch (error) {
                return "med"
            }

        },
        ShowToastForCancel() {
            this.toastMessage = "Your subscription is cancelled."
            this.showT = true;
            this.cancelSubs = false;
        },
        ShowToastForCancelError(message) {
            this.toastMessage = `Error : ${message}`
            this.showT = true;
            this.cancelSubs = false;
        },
        async getSubscriptions() {
            try {
                //const lastChecked = this.$store.getters.lastCheckedSubscription;
                //const ONE_HOUR = 60 * 60 * 1000;
                const shouldRefresh = true //!lastChecked || (Date.now() - parseInt(lastChecked)) > ONE_HOUR;

                if (shouldRefresh) {
                    this.isLoading = true;
                    const response = await this.$axios.get(`${this.baseUrl}/api/subscription-items`);
                    if (response.data.status === 'success') {
                        await this.$store.dispatch('updateSubscriptions', {
                            items: response.data.subscriptions,
                            timestamp: Date.now().toString()
                        });
                        this.subscriptions = response.data.subscriptions;
                    }
                } else {
                    this.subscriptions = this.$store.getters.subscriptionItems;
                }
            } catch (error) {
                console.error('Failed to fetch progress:', error);
            } finally {
                this.isLoading = false;
            }

        },

        async getTransactions() {
            try {
                const lastChecked = this.$store.getters.lastCheckedTransactions;
                const ONE_HOUR = 60 * 60 * 1000;
                const shouldRefresh = !lastChecked || (Date.now() - parseInt(lastChecked)) > ONE_HOUR;

                if (shouldRefresh) {
                    this.isLoading = true;
                    const response = await this.$axios.get(`${this.baseUrl}/api/transaction-items`);
                    if (response.data.status === 'success') {
                        await this.$store.dispatch('updateTransactionItems', {
                            items: response.data.transactions,
                            timestamp: Date.now().toString()
                        });
                        this.transactionItems = response.data.transactions;
                    }
                } else {
                    this.transactionItems = this.$store.getters.transactionItems;
                }
            } catch (error) {
                console.error('Failed to fetch progress:', error);
            } finally {
                this.isLoading = false;
            }
        },
    },

    created() {

    }
}
</script>

<style scoped>
.payment-history-div {
    width: 50%;
    margin-left: 25px;
}
</style>
